import { setContext } from '@apollo/client/link/context'

const createAuthLink = getAccessToken =>
  setContext((_, { headers }) => ({
    headers: {
      ...headers,
      Accept: 'application/json',
      accessToken: getAccessToken(),
    },
  }))

export default createAuthLink
